module.exports = __webpack_public_path__ + "static/media/hero-image-with-logo.b48e20b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero-image-with-logo.jpg
// module id = 51
// module chunks = 0